import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const definitionApi = createApi({
  reducerPath: 'definitionApi',
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: () => ({
        method: 'GET',
        path: `User/GetAllUsers`,
      }),
    }),
    getAnUser: builder.query({
      query: ({ text }) => ({
        path: `User/GetAnUser?fullNameQuery=${text}`,
        method: 'GET',
      }),
    }),
    getUserById: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `User/PublicRegister/${id}`,
      }),
    }),
    getSearchCompany: builder.query({
      query: ({ text }) => ({
        method: 'GET',
        path: `Customer/GetSearchCustomers/${text}`,
      }),
    }),
    updateUser: builder.mutation({
      query: ({ id, data }) => ({
        data,
        method: 'PUT',
        path: `User/PublicRegister/${id}`,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const definitionApiReducerName = definitionApi.reducerPath;
export const definitionApiReducer = definitionApi.reducer;
export const definitionApiMiddleware = definitionApi.middleware;

export const {
  useGetAllUsersQuery,
  useLazyGetAllUsersQuery,
  useGetAnUserQuery,
  useLazyGetAnUserQuery,
  useGetUserByIdQuery,
  useLazyGetUserByIdQuery,
  useGetSearchCompanyQuery,
  useUpdateUserMutation,
} = definitionApi;
